interface SpecificTabsContentProps {
  tabs: any[],
  currentTab: number,
  setCurrentTab: (tab: number) => void,
}

export default function SpecificTabs({ tabs, currentTab, setCurrentTab }: SpecificTabsContentProps): JSX.Element {
  return (
    <>
      {tabs.map((tab: any) => (
        <div className="nav-item" key={tab.value}>
          <a
            role="tab"
            className={`nav-link ${currentTab === tab.tabval ? 'active' : ''}`}
            tabIndex={0}
            href="#"
            onClick={() => setCurrentTab(tab.tabval)}
          >
            {tab.name}
          </a>
        </div>
      ))}
    </>
  );
}
